import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { MediaCategory } from '../../../models/media/media-category.model';
import { ViewerTemplate, SaveViewerTemplateRequest } from '../../../models/media/vet-sale-template.model';
import * as VetSettingsActions from './vet-settings.actions';
import * as VetSettingsSelectors from './vet-settings.selectors';

@Injectable({
  providedIn: 'root'
})
export class VetSettingsFacade {
  mediaCategories$: Observable<MediaCategory[]> = this.store.select(VetSettingsSelectors.selectMediaCategories);
  viewerTemplates$: Observable<ViewerTemplate[]> = this.store.select(VetSettingsSelectors.selectViewerTemplates);
  selectSaveViewerTemplates$: Observable<boolean> = this.store.select(VetSettingsSelectors.selectSaveViewerTemplates);
  // Add other facades as needed...

  constructor(private store: Store) { }

  loadMediaCategories(viewerTemplateId: number): void {
    this.store.dispatch(VetSettingsActions.loadMediaCategories({ viewerTemplateId }));
  }

  loadViewerTemplates(): void {
    this.store.dispatch(VetSettingsActions.loadViewerTemplates());
  }

  saveViewerTemplate(request: SaveViewerTemplateRequest): void {
    this.store.dispatch(VetSettingsActions.saveViewerTemplate({ request }));
  }
  handleClearState() {
    this.store.dispatch(VetSettingsActions.resetState());
  }
  // Add other facade methods as needed...
}
